import React, { useReducer } from 'react';

import ApplicationContext from './applicationContext';
import applicationDefaultState from './applicationDefaultState';
import applicationReducer from './applicationReducer';

interface ApplicationStateProps {
  /** The actual application component */
  children: React.ReactNode;
}

export const ApplicationState: React.FC<ApplicationStateProps> = ({
  children
}: ApplicationStateProps) => {
  // Only restore session if both user AND token exist in localStorage.
  // Prevents redirect loops when token has expired but stale user data remains.
  const hasToken = !!localStorage.getItem('token');
  const localState: User = hasToken && localStorage.getItem('user')
    ? JSON.parse(localStorage.getItem('user') ?? '')
    : undefined;

  // Clean up stale localStorage if token is missing
  if (!hasToken && localStorage.getItem('user')) {
    localStorage.removeItem('user');
  }

  const [state, dispatch] = useReducer(
    applicationReducer,
    localState ? { user: localState } : applicationDefaultState
  );

  return (
    <ApplicationContext.Provider
      value={{
        dispatch,
        state
      }}
    >
      {children}
    </ApplicationContext.Provider>
  );
};
export default ApplicationState;
